import { render, staticRenderFns } from "./UserOnlineBody.vue?vue&type=template&id=521e2e5e&"
import script from "./UserOnlineBody.vue?vue&type=script&lang=ts&"
export * from "./UserOnlineBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports